import { defineNotificationCategory, extractRelativeActionUrl, requireFields } from './types';

export const demandFrameworkChangedDescriptor = defineNotificationCategory(
  'demand_framework_changed',
  {
    isAvailable: requireFields('previousFrameworkName', 'newFrameworkName'),
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/idea-management/demands`,
    serverCopy: {
      titleKey: 'demandFrameworkChanged.title',
      bodyKey: 'demandFrameworkChanged.body',
      values: (data) => ({
        previousFrameworkName: data.previousFrameworkName,
        newFrameworkName: data.newFrameworkName,
      }),
    },
    pills: () => ['Demand Views'],
  },
);

export const demandStageChangedDescriptor = defineNotificationCategory('demand_stage_changed', {
  isAvailable: requireFields('demandTitle', 'stageName'),
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Demand Views'],
});
